import { styled } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { forwardRef, useState, useImperativeHandle, useEffect, createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends, d as _objectDestructuringEmpty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import { createPortal } from 'react-dom';
import ClickOutside from '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import { Manager, Reference, Popper } from 'react-popper';
import Item from './Item.js';
import Divider from './Divider.js';

const _excluded = ["theme"];
var DropdownList = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    bg: `${theme.palette.common.white}`,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[10],
    borderRadius: `${theme.shape.borderRadius}px`,
    cursor: 'pointer'
  }, props);
})``;

var DropdownLabel = styled(Div).attrs(_ref => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return _objectSpread2({
    display: 'flex',
    alignItems: 'center'
  }, props);
})``;

const defaultTestIds = {
  button: 'dropdownButton',
  contentContainer: 'dropdownContent'
};
const DropdownMenuComponent = /*#__PURE__*/forwardRef(function DropdownMenu({
  label = 'Open',
  icon,
  iconOnly,
  styles,
  placement = 'bottom-start',
  children,
  isDisabled = false,
  testIds = defaultTestIds,
  renderList,
  renderButton,
  showCaret = false,
  buttonProps = {},
  onIsOpenChange,
  openByDefault = false,
  portalContainer,
  onClickOutside
}, forwardedRef) {
  const [isOpen, setIsOpen] = useState(openByDefault);
  const openDropdown = () => setIsOpen(true);
  const closeDropdown = () => setIsOpen(false);
  const toggleDropdown = () => setIsOpen(prevIsOpen => !prevIsOpen);
  useImperativeHandle(forwardedRef, () => ({
    openDropdown,
    closeDropdown,
    toggleDropdown
  }));
  useEffect(() => {
    onIsOpenChange === null || onIsOpenChange === void 0 ? void 0 : onIsOpenChange(isOpen);
  }, [isOpen, onIsOpenChange]);

  // TODO Move to a separate component and check popper version
  const renderPopperContent = () => /*#__PURE__*/createElement(Popper, {
    placement: placement
  }, ({
    ref,
    style
  }) => {
    var _styles$active;
    return /*#__PURE__*/createElement(ClickOutside, {
      onClickOutside: handleClickOutside,
      styles: {
        root: _objectSpread2({
          position: 'relative'
        }, isOpen && !!(styles !== null && styles !== void 0 && (_styles$active = styles.active) !== null && _styles$active !== void 0 && _styles$active.root) ? styles.active.root : styles === null || styles === void 0 ? void 0 : styles.root)
      }
    }, /*#__PURE__*/createElement(Div, _extends({
      testId: testIds === null || testIds === void 0 ? void 0 : testIds.contentContainer
      // @ts-ignore
      ,
      elRef: ref,
      style: style,
      whiteSpace: "nowrap"
    }, styles === null || styles === void 0 ? void 0 : styles.menuContainer), /*#__PURE__*/createElement(DropdownList, styles === null || styles === void 0 ? void 0 : styles.menu, renderList && renderList({
      closeDropdown
    }), !renderList && children)));
  });
  const renderPopper = () => {
    if (isOpen) {
      return portalContainer ? /*#__PURE__*/createPortal(renderPopperContent(), portalContainer) : renderPopperContent();
    }
    return null;
  };
  const handleClickOutside = event => {
    event.stopPropagation();
    onClickOutside ? onClickOutside(closeDropdown) : closeDropdown();
  };
  return /*#__PURE__*/createElement(Manager, null, /*#__PURE__*/createElement(Reference, null, ({
    ref
  }) => {
    var _styles$button, _styles$button2, _styles$label, _styles$label2;
    return /*#__PURE__*/createElement(Fragment, null, renderButton && renderButton({
      openDropdown,
      closeDropdown,
      toggleDropdown,
      isDropdownOpened: isOpen,
      ref
    }), !renderButton && /*#__PURE__*/createElement(Button, _extends({
      testId: testIds === null || testIds === void 0 ? void 0 : testIds.button,
      onClick: () => setIsOpen(!isOpen),
      styles: {
        text: _objectSpread2({
          width: '100%'
        }, styles === null || styles === void 0 ? void 0 : (_styles$button = styles.button) === null || _styles$button === void 0 ? void 0 : _styles$button.text),
        root: _objectSpread2({}, styles === null || styles === void 0 ? void 0 : (_styles$button2 = styles.button) === null || _styles$button2 === void 0 ? void 0 : _styles$button2.root)
      },
      disabled: isDisabled
    }, buttonProps, {
      // @ts-ignore
      elRef: ref
    }), /*#__PURE__*/createElement(DropdownLabel, styles === null || styles === void 0 ? void 0 : (_styles$label = styles.label) === null || _styles$label === void 0 ? void 0 : _styles$label.root, !!icon && /*#__PURE__*/createElement(Icon, icon), !iconOnly && /*#__PURE__*/createElement(Span, styles === null || styles === void 0 ? void 0 : (_styles$label2 = styles.label) === null || _styles$label2 === void 0 ? void 0 : _styles$label2.text, label)), showCaret && /*#__PURE__*/createElement(Icon, {
      glyph: icons.CHEVRON_DOWN,
      rotate: !isOpen ? -90 : 0,
      styles: {
        root: {
          ml: 'auto '
        }
      }
    })));
  }), renderPopper());
});
const DropdownMenu = Object.assign(DropdownMenuComponent, Item, Divider);

export default DropdownMenu;
